var AppRouter = Backbone.Router.extend({

    routes: {
        "":"routeFromURL",
        ":page":"routeFromURL",
        ":page/":"routeFromURL",
        ":page/:trend":"routeFromURL",
    },

    routeFromURL:function(page, trend){
        if(page !== null && page !== undefined) App.currentPage = page;
        else App.currentPage = "disc"
        if(trend !== null && trend !== undefined) App.selectedTrend = trend;
        else App.selectedTrend = "";

        if(App.currentPage == "disc2" || App.currentPage == "trend2"){
            App.dataApp = "second";
        }

        App.updateFromRouter();
    },
    
    updateRoute:function(triggerize){
        this.navigate( App.currentPage +"/" +App.selectedTrend, {trigger: triggerize});
    },

});

module.exports = AppRouter;